<template>
  <div class="bg-[#fff] h-[100vh]">
    <dg-head>
      <div class="flex items-center">
        <p class="cursor-pointer  pr-[40]" @click="push({ path: '/login' })"> <i class="icon">&#xe677;</i> 登录</p>
        <a :href="ENV.official" target="_blank"> <el-button size="mini" type="primary">返回首页</el-button></a>
      </div>
    </dg-head>
    <div class="min-h-[85vh] pt-[100] md:pt-[50] md:min-h-[80vh]">
      <div class="w-[400] mx-[auto] ">
        <div class="flex justify-between mb-[24]">
          <p class="t-[24] t-[#303133] font-500">注册</p>
          <div class="flex  overflow-hidden cursor-pointer rounded-[2] leading-[32] text-center">
            <p class="w-[80] border-[#dcdfe6] border-y-[1px]  border-l-[1px] border-solid"
              :class="{ 't-[#fff] bg-[theme] border-[theme]': registerType == 1 }" @click="changeLoginType(1)">企业</p>
            <p :class="{ 't-[#fff] bg-[theme] border-[theme]': registerType == 0 }" @click="changeLoginType(0)"
              class="w-[80] border-[#dcdfe6] border-y-[1px] border-r-[1px] border-solid">自然人</p>
          </div>
        </div>
        <dg-alert-box class="md:zoom-[0.9]">
          <el-form :model="registerForm" ref="registerFormRef" label-width="1px">
            <el-form-item label="" prop="enterpriseName" :rules="rules.enterpriseName" class="relative mb-[24]"
              v-if="registerType == 1">
              <!--   -->
              <el-input size="large" class="large_input" placeholder="*请填写注册的企业名称"
                v-model="registerForm.enterpriseName">
              </el-input>
              <p class="t-[12] t-[#a1a1a1] absolute leading-[20] right-[0]">请与营业执照保持一致</p>
            </el-form-item>
            <el-form-item label="" prop="enterpriseCode" :rules="rules.enterpriseCode" class="relative mb-[24]"
              v-if="registerType == 1">
              <el-input size="large" class="large_input" placeholder="*请填写统一社会信用代码"
                v-model="registerForm.enterpriseCode">
              </el-input>
              <p class="t-[12] t-[#a1a1a1] absolute leading-[20] right-[0]">请与营业执照保持一致</p>
            </el-form-item>
            <template v-if="registerType == 0">
              <el-form-item label="" prop="name"
                :rules="[{ required: true, message: registerType == 0 ? '请填写姓名' : '请填写经办人姓名', trigger: 'blur' }]"
                class="relative mb-[24 ">
                <el-input size="large" class="large_input " :placeholder="registerType == 0 ? '*请填写姓名' : '*请填写经办人姓名'"
                  v-model="registerForm.name"> </el-input>
              </el-form-item>
              <el-form-item label="" prop="mobile" class="relative mb-[24]" :rules="[
                { required: true, message: '请填写手机号', trigger: 'blur' },
                { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请填写手机号' }
              ]">
                <el-input size="large" class="large_input" placeholder="*请填写手机号" maxlength="11"
                  v-model="registerForm.mobile"> </el-input>
              </el-form-item>
            </template>
            <div class="flex justify-between" v-else>
              <el-form-item label="" prop="name"
                :rules="[{ required: true, message: registerType == 0 ? '请填写姓名' : '请填写经办人姓名', trigger: 'blur' }]"
                class="relative mb-[24] w-[164]">
                <el-input size="large" class="large_input" :placeholder="registerType == 0 ? '*请填写姓名' : '*请填写经办人姓名'"
                  v-model="registerForm.name">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="mobile" class="relative mb-[24] w-[226]" :rules="[
                { required: true, message: '请填写手机号', trigger: 'blur' },
                { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请填写手机号' }
              ]">
                <el-input size="large" class="large_input" placeholder="*请填写手机号" maxlength="11"
                  v-model="registerForm.mobile">
                </el-input>
              </el-form-item>
            </div>
            <!-- <el-form-item label="" prop="password" :rules="rules.password" class="relative mb-[24]">
              <el-input size="large" class="large_input" placeholder="*请设置登录密码" show-password
                v-model="registerForm.password">
              </el-input>
            </el-form-item> -->

            <div class="relative">
              <el-form-item label="" prop="password" :rules="rules.password" class="relative mb-[24]">
                <el-input class="large_input" size="large" @focus="intensityVisible = true"
                  @blur="intensityVisible = false" placeholder="*请设置登录密码" maxlength="32" show-password
                  v-model="registerForm.password">
                </el-input>
              </el-form-item>
              <dg-pasw-intensity v-show="intensityVisible" :value="registerForm.password"></dg-pasw-intensity>
            </div>

            <el-form-item label="" class="mb-[24]" prop="catchcode"
              :rules="[{ required: true, message: '请输入图形码', trigger: 'blur' }]">
              <div class="flex">
                <div class="relative flex-1 pr-[10]">
                  <el-input size="large" class="large_input" placeholder="请输入图形码" v-model="registerForm.catchcode">
                  </el-input>
                </div>
                <div class="verificationCode w-[130] pl-[10]" @click="getcaptcha">
                  <img :src="verificationCode" class="w-[100%] h-[48]" alt="" />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="" prop="smsCode" :rules="[{ required: true, message: '请输入短信验证码', trigger: 'blur' }]"
              class="mb-[24]">
              <div class="relative">
                <el-input size="large" class="large_input" placeholder="请输入短信验证码" v-model="registerForm.smsCode">
                  <template v-slot:suffix>
                    <div
                      class="suffix cursor-pointer border-l-[1] border-[#d5dae5] border-solid w-[100] leading-[31] my-[9] t-[theme]"
                      @click="handleSend">{{ CountDownStatus ? "发送短信" :
                        `${CountDownNum}/s` }}</div>
                  </template>
                  
                </el-input>
                <div v-show="showPrompt"
                    class="absolute bg-[#F0F2F5] h-[22] w-[246] radius-[4] leading-[22] top-[50] right-[0] t-[12] text-center">
                    <span class="t-[#303133]  zoom-[0.9]">验证码已发送给{{ mobile }}，10分钟内有效</span>
                  </div>
              </div>
              <!-- <div class="aui-rel aui-item smsCode">
                    <el-input size="large" placeholder="请输入短信验证码" v-model="registerForm.smsCode">
                      <div slot="suffix" class="suffix" @click="handleSend('registerFormRef')">{{ CountDownStatus ?
                        "发送短信"
                        : `${CountDownNum}/s` }}</div>
                    </el-input>
                    <div v-show="showPrompt"
                      class="aui-position-abs aui-bg-F0F2F5 h-22 w-246 aui-radius-4 aui-line-22 aui-t-50 aui-r-0 aui-font-size-12 aui-text-align-c">
                      <span class="aui-303133 aui-zoom-09">验证码已发送给{{ mobile }}，10分钟内有效</span>
                    </div>
                  </div> -->

            </el-form-item>
            <div class="t-[12]"><el-checkbox v-model="isProtocol"></el-checkbox>
              <span>同意</span> <a href="#/protocolRegister" target="_blank" class="!t-[theme]">《用户协议》</a>
            </div>
            <div class="mt-[14]">
              <el-button class="w-[100%]" type="primary" @click="handleregister('registerFormRef')">注册</el-button>

            </div>

          </el-form>
        </dg-alert-box>
      </div>
    </div>
    <dg-copyright></dg-copyright>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import { deepCopyRef, encryptDES } from "@/assets/js/utils";
import CountDown from "@/assets/js/countDown";
export default {
  mixins: [mixin],
  data() {
    var enterpriseName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写注册的企业名称'));
      } else if (value.replace(/[^\u0000-\u00ff]/g, "aa").length < 8) {
        callback(new Error('企业名称最少4汉字'));
      } else {
        callback();
      }
    }
    var enterpriseCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写统一社会信用代码'));
      } else if (!(/^[A-Za-z0-9]{18}$/).test(value)) {
        callback(new Error('社会统一信用代码为18位数，大小字母和数字组成'));
      } else {
        callback();
      }
    }
    var password = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请设置登录密码'));
      } else if (!(/^(?!.*(.)\1{2,})(?=.*[a-zA-Z].*[0-9]|[a-zA-Z].*[!@#$%^&*()_+[\]{};':"\\|,.<>?`~]|[0-9].*[!@#$%^&*()_+[\]{};':"\\|,.<>?`~]).{6,32}$/).test(value)) {
        callback(new Error('设置密码格式错误'));
      } else {
        callback();
      }
    }
    return {

      rules: {
        enterpriseName: [
          { required: true, validator: enterpriseName }
        ],
        enterpriseCode: [
          { required: true, validator: enterpriseCode}
        ],
        password: [
          { required: true, validator: password }
        ],
      },
      registerType: 1,
      CountDownNum: 60,
      intensityVisible: true,
      CountDownStatus: true,
      isProtocol: true,
      verificationCode: "",
      registerTypeData: [
        { type: 0, name: "自然人", api: "/customer/auth/personRegist" },
        { type: 1, name: "企业", api: "/customer/auth/enterpriseRegist" }
      ],
      registerForm: {
        enterpriseCode: "", // 企业统一信用代码
        enterpriseName: "", // 企业名称
        mobile: "", // 手机号
        name: "", // 姓名
        catchcode: "", // 图像吗
        password: "", // 密码，cookie值加上当前日期做密钥（JSESSIONID-yyyy-MM-dd），对明文进行des加密
        smsCode: "", // 短信验证码
        saleName: "", // 分销员名称
        saleUserId: "" // 分销员用户ID
      },
      mobile:'',
      countDown: {},
      showPrompt: false,
    };
  },
  methods: {
    changeLoginType(type) {
      this.registerType = type
      this.$refs['registerFormRef'].clearValidate();
      Mirror.emit('tips_el_alert_box_close')
    },
    /**
     * @author 伟健 / 张
     * @name 注册
     * @param
     * @return
     */
    handleregister(formName) {
      if (!this.isProtocol) {
        // this.$message({
        //   message: "请同意协议",
        //   type: "warning"
        // });
        //  Mirror.watch(['tips_bus', "tips_el_alert_box_open"]
        Mirror.emit('tips_bus', {
          msg: '请同意协议',
          type: "warning"
        })
        return;
      }



      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _registerForm = deepCopyRef(this.registerForm);
          _registerForm.password = encryptDES(_registerForm.password);
          ajax.post({
            url: this.registerTypeData[this.registerType].api,
            data: _registerForm,
            self: this,
            success: res => {
              if (res) {
                // this.$message({
                //   message: "注册成功",
                //   type: "success"
                // });
                Mirror.emit('tips_bus', {
                  msg: "注册成功",
                  type: "success",
                });
                setTimeout(() => {
                  this.push({ path: "/login" });
                }, 1500);
              }
            },
          });
        }
        // else {
        //   let keys = Object.keys(fields);
        //   this.$message({
        //     message: `请输入${this.getMesgText(keys[0])}`,
        //     type: "error"
        //   });
        //   console.log("error ", fields);
        // }
      });
    },
    /**
     * @author 伟健 / 张
     * @name 根据key获取提示
     * @param
     * @return
     */
    getMesgText(key) {
      let d = {
        name: "姓名",
        password: "密码",
        smsCode: "短信验证码",
        catchcode: "图像码",
        mobile: "手机号",
        enterpriseName: "企业名称",
        enterpriseCode: "企业统一信用代码"
      };
      return d[key];
    },
    /**
     * @author 伟健 / 张
     * @name 发送短信
     * @param
     * @return
     */
    handleSend() {
      this.showPrompt = false;
      Mirror.emit('tips_el_alert_box_close');
      if (!this.countDown.checkStatus()) {
        return;
      }

      let hasError = false
      this.$refs['registerFormRef'].validateField(['mobile', 'catchcode'], err => {
        if (err) {
          hasError = true
          return;
        }
      })
      if (!hasError) {
        ajax.post({
          url: "/customer/common/sendSmsCode",
          self: this,
          data: {
            catchcode: this.registerForm.catchcode, // 图形验证码
            mobile: this.registerForm.mobile // 手机号码
          },
          success: res => {
            this.showPrompt = true;
            if (res) {
              this.countDown.start();
              this.mobile = this.registerForm.mobile
            }
          },
          fail: () => {
            this.getcaptcha();
          }
        });
      }
    },
    /**
     * @author 伟健 / 张
     * @name 倒计时
     * @param
     * @return
     */
    handleCountDown() {
      this.countDown.start();
    },
    /**
     * @author 伟健 / 张
     * @name 获取图像码
     * @param
     * @return
     */
    getcaptcha() {
      ajax.post({
        url: "/customer/common/getcaptcha",
        data: {},
        self: this,
        success: res => {
          if (res) {
            this.verificationCode = res;
          }

        },
      });
    }
  },
  created() {
    this.countDown = new CountDown({
      self: this,
      /*   这两参数必填
       "CountDownNum": 30,
       "CountDownStatus": true,
       */
      id: "register"
    });
    this.getcaptcha();
    this.registerForm.saleName = this.$route.query.saleUserName || '';
    this.registerForm.saleUserId = this.$route.query.saleUserId || '';
  }
};
</script>
<style scoped></style>
